export * from './location-detail';
